/** Handle generic customer staff type */
export enum CustomerStaffType {
  UNKNOWN = 0,
  CUSTOMER = 1,
  STAFF = 2,
  GROUP_CUSTOMERS = 3,
  GROUP_STAFF = 4
}

/** Handle customer staff state */
export enum CustomerStaffState {
  UNKNOWN = 0,
  ARCHIVED = 1,
  ACTIVE = 2,
  AUTHORIZED = 3,
  BLOCKED = 4,
  CHECK_IN = 5,
  INCOMING = 6,
  OUTCOMING = 7,
  NOT_ARRIVED = 8,
  OVERTIME = 9,
  BOOKED = 10,
}
